'use client';
import styled from 'styled-components';

import { Spacers } from '@styles/theme';

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
`;

export const CountryCodePrefix = styled.div`
  display: flex;
  align-items: center;
  padding: ${Spacers.SM}rem ${Spacers.BASE}rem;
  height: 2.625rem;
  background-color: ${({ theme }) => theme.colors.backgroundAccent};
  border-radius: 0.5rem;
  color: ${({ theme }) => theme.colors.typographyHeadersLight};
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  gap: ${Spacers.XS}rem;
`;

export const PhoneInputsContainer = styled.div`
  display: flex;
  gap: ${Spacers.XS}rem;
`;

export const AddressInputsContainer = styled.div`
  display: flex;
  gap: ${Spacers.LG}rem;
`;

export const AddressContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  border-radius: ${Spacers.XS}rem;
  border: ${(props) => `1px solid ${props.theme.colors.backgroundAccent}`};
  padding: ${Spacers.BASE}rem;
  color: ${({ theme }) => theme.colors.typographyBodyLight};
  gap: ${Spacers.BASE}rem;
`;

export const LocationContainer = styled.div`
  display: flex;
  width: 4rem;
  height: 4rem;
  align-items: center;
  justify-content: center;
  border-radius: ${Spacers.XS}rem;
  color: ${({ theme }) => theme.colors.actionDefault};
  background-color: ${({ theme }) => theme.colors.brandAccent};
`;
